var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cause-contain"},[_vm._m(0),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.noData.title))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("../../../assets/appraise/nodata.png")}})])
}]

export { render, staticRenderFns }